import api from "@/utils/axios";

export default {
  async getByCustomer(customerId) {
    try {
      const response = await api.get(`/users/${customerId}/bikes`);
      return response.data;
    } catch (error) {
      error.message = `Failed loading bikes for customer with id ${customerId}: ${error.message}`;
      throw error;
    }
  },

  getByQRCode(code) {
    return api
      .get(`/bikes/qrcode/${code}`)
      .then((response) => response.data)
      .catch((error) => {
        if (error.response.status === 404) {
          error.message = `A bike with the QR code ${code} does not exist.`;
        }
        error.message = `Failed loading bike by QR code: ${error.message}`;
        throw error;
      });
  },

  getById(id) {
    return api.get(`/bikes/${id}`).then((response) => response.data);
  },

  async update(bikeId, params) {
    let response;
    try {
      response = await api.patch(`/bikes/${bikeId}/`, params);
    } catch (error) {
      const status = error.response?.status;
      const data = error.response?.data;
      const hasFieldErrors =
        (status === 400 || status === 409) &&
        data !== null &&
        typeof data === "object" &&
        !Array.isArray(data) &&
        !("detail" in data);
      if (!hasFieldErrors) {
        error.message = `Failed updating bike: ${error.message}`;
      }
      throw error;
    }

    console.log("BIKE: updated with success", response.data);
    return response.data;
  },

  async create(params) {
    let response;
    try {
      response = await api.post("/bikes/", params);
    } catch (error) {
      error.message = `Failed creating bike: ${error.message}`;
      throw error;
    }

    console.log("BIKE: created with success", response.data);
    return response.data;
  },

  async createOrUpdate(params) {
    if (!params.id) return await this.actions.bikes.create(params);

    return await this.actions.bikes.update(params.id, params);
  },
};
